// extracted by mini-css-extract-plugin
module.exports = {"wrap":"share-form_wrap_21NTc","height":"share-form_height_1S22f"};